// components/onboarding/OnboardingHistoryDrawer.js

import React from "react";

import { X, History } from "lucide-react";

import { formatDateTime } from "../../helpers/formatDateTime";

const OnboardingHistoryDrawer = ({ open, onClose, history }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 top-10 md:top-12 z-50 bg-black/30" onClick={onClose}>
      <div
        className="absolute right-0 top-0 h-full w-full md:w-[500px] bg-white shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}

        <div className="flex items-center justify-between p-5 border-b">
          <div className="flex items-center gap-2">
            <History size={20} />

            <h2 className="font-semibold text-lg">Onboarding History</h2>
          </div>

          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full"
          >
            <X size={18} />
          </button>
        </div>

        {/* Content */}

        <div className="overflow-y-auto h-[calc(100%-80px)] p-4 space-y-4">
          {history?.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-full text-center">
              <History size={50} className="text-gray-300 mb-3" />

              <h3 className="text-lg font-medium text-gray-600">
                No History Available
              </h3>

              <p className="text-sm text-gray-400 mt-1">
                No onboarding activities found.
              </p>
            </div>
          ) : (
            history.map((item) => (
              <div
                key={item._id}
                className="border border-gray-200 rounded-xl p-4 bg-white shadow-sm"
              >
                {/* Title */}
                <div className="mb-3">
                  <p className="text-xs text-gray-500 uppercase tracking-wide">
                    Title
                  </p>

                  <p className="font-medium text-gray-800">
                    {item.checklistTitle}
                  </p>
                </div>

                {/* Status */}
                <div className="mb-3">
                  <p className="text-xs text-gray-500 uppercase tracking-wide">
                    Status
                  </p>

                  <span
                    className={`inline-flex px-2 py-1 rounded-full text-xs font-medium ${
                      item.actionType === "CHECKED"
                        ? "bg-green-100 text-green-700"
                        : item.actionType === "UNCHECKED"
                          ? "bg-red-100 text-red-700"
                          : "bg-blue-100 text-blue-700"
                    }`}
                  >
                    {item.actionType}
                  </span>
                </div>

                {/* Remarks */}
                {item.remarks && (
                  <div className="mb-3">
                    <p className="text-xs text-gray-500 uppercase tracking-wide">
                      Remarks
                    </p>

                    <p className="text-sm text-gray-700">{item.remarks}</p>
                  </div>
                )}

                {/* Updated By */}
                <div className="mb-3">
                  <p className="text-xs text-gray-500 uppercase tracking-wide">
                    Updated By
                  </p>

                  <p className="text-sm text-gray-700">
                    {item.actionBy?.firstName} {item.actionBy?.lastName}
                  </p>
                </div>

                {/* Date */}
                <div>
                  <p className="text-xs text-gray-500 uppercase tracking-wide">
                    Date
                  </p>

                  <p className="text-sm text-gray-700">
                    {formatDateTime(item.actionDate)}
                  </p>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default OnboardingHistoryDrawer;
